import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { CreateAgentInput } from "tekkr-common/dist/model/agent/agent";

interface CreateAgentData {
    id: string;
    createdAt: string;
}

interface Options {
    onSuccess?: (data: CreateAgentData) => void;
}

export function useCreateAgentMutation(options?: Options) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (input: CreateAgentInput): Promise<CreateAgentData> => {
            const res = await apiClient.createAgent({
                body: input,
            });
            if (res.status !== 201) {
                throw new Error("Failed to create agent");
            }
            return res.body;
        },
        onSuccess: async (data) => {
            await queryClient.invalidateQueries({ queryKey: ["agents"] });
            options?.onSuccess?.(data);
        },
    });
}
